import React, {Component} from 'react';
import './multipleChoiceAnswer.css';

export class MultipleChoiceAnswer extends Component {
  componentWillUnmount() {
    this.props.clearSurvey?.();
  }

  render() {
    const {question, answer, onChange, tabIndex} = this.props;
    const options = question.options?.options || [];
    return <div className="br-survey-choice-answer" role="radiogroup"
      aria-label={question.question || 'Choose one option'}>
      {options.map((option, index) => {
        const key = typeof option === 'string' ? option : option.key;
        const value = typeof option === 'string' ? option : option.value;
        return <label className={`br-survey-choice-answer__option${key === answer?.answer ? ' br-survey-choice-answer__option--selected' : ''}`} key={index}>
          <input type="radio" name={`survey-${question._id || 'choice'}`}
            value={key} checked={key === answer?.answer}
            onChange={() => onChange?.(key)} tabIndex={tabIndex} />
          <span>{value}</span>
        </label>;
      })}
    </div>;
  }
}

export default MultipleChoiceAnswer;
